export default function makeOnCut(options) {
  return {
    onCut: function onCut(event, editor) {
      event.preventDefault();
      event.stopPropagation();

      if (editor.value.selection.isExpanded) {
        editor.copyFragmentToClipboard(event, editor.value.fragment).deleteBackward(0);
      }
    }
  };
}